module.exports = __webpack_public_path__ + "static/img/3-7.783966f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-3/3-7.jpg
// module id = 742
// module chunks = 1